import UISignals from "@baseUI/controllers/UISignals";
import UIFacade from "../UIFacade";
import Facade from "@/Facade";
import Platform from "@/utils/Platform";
import Signals from "@baseUI/controllers/UISignals";

export default class SlotEventManager {


    constructor(uiModel, uiView) {

        this.uiModel = uiModel
        this.uiView = uiView

       // UIFacade.systemDIV = document.getElementById('system')

        document.addEventListener("ui:resize", this.onResize.bind(this))
        document.addEventListener("tap", this.onTap.bind(this))
        document.addEventListener("ui:init", this.onInit.bind(this))
        document.addEventListener("ui:setFreeSpin", this.onSetFreeSpin.bind(this))
        document.addEventListener("setBuyFreeSpin", this.onSetBuyFreeSpin.bind(this))
        document.addEventListener("setFreespinsLeft", this.onSetFreespinsLeft.bind(this))
        document.addEventListener("setTotalWin", this.onSetTotalWin.bind(this))
        document.addEventListener("showComponent", this.onShowComponent.bind(this))
        document.addEventListener("hideComponent", this.onHideComponent.bind(this))
        document.addEventListener("setButtonState", this.onSetButtonState.bind(this))
        document.addEventListener("ui:setWin", this.onSetWin.bind(this))
        document.addEventListener("ui:setBalance", this.onSetBalance.bind(this))
        document.addEventListener("ui:setBet", this.onSetBet.bind(this))
        document.addEventListener("setAutospinValue", this.onSetAutospinValue.bind(this))
        document.addEventListener("setAutospinStop", this.onSetAutospinStop.bind(this))

        document.addEventListener("showPopup", this.onShowPopup.bind(this))
        document.addEventListener("closeCustomPopUp", this.onClosePopup.bind(this))

        //  TODO : in other file - from UI
        //  UISignals.currentBetIndexHasChanged.add(this.onCurrentBetIndexHasChanged, this)
        UISignals.setStateSettings.add(this.onChangeState.bind(this))
        UISignals.startAutoplay.add(this.onStartAutoplay.bind(this))
        UISignals.stopAutoplay.add(this.onStopAutoplay.bind(this))
        UISignals.currentBetIndexHasChanged.add(this.onBetChange.bind(this))

    }

    onChangeState(keyBtnState, state) {
        switch ( keyBtnState ) {
            case "settingsMusic":
                document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'music', value: state}}))
                break
            case "settingsSounds":
                document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'sound', value: state}}))
                break
            case "settingsSpace":
                document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'space', value: state}}))
                break
            case"sound_music":
                document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'music', value: state}}))
                document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'sound', value: state}}))
                break
        }

    }

    onStartAutoplay(settingsObject) {
        UIFacade.model.autoplaySettingsData = settingsObject
        document.dispatchEvent(new CustomEvent('changeModelUi', {
            detail: {
                name: 'autoplaySettings', value: UIFacade.model.autoplaySettingsData
            }
        }))
    }

    onStopAutoplay() {
        UIFacade.model.isAutospin = false
        document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'autoplayStop'}}))
    }

    onResize(e) {
        const detail = e.detail
        UIFacade.model.resizeData = e.detail

        if (UIFacade.menuContainer && window.app.stage) {
            UISignals.resize.dispatch()
        }
    }

    onInit(data) {
        const detail = data.detail
        UIFacade.model.initData = detail
        UISignals.startUI.dispatch(detail.container, detail.menuContainer)
    }

    onSetFreeSpin(e) {
        const detail = e.detail
        UISignals.setFreeSpin.dispatch(e.detail.value)

        if (detail.value) {
            // UISignals.setStateUIButtons.dispatch({
            // spin: { visible: false},
            // autoplay: { visible: false},
            // maxBet: { visible: false},
            // autoplayCounter: { visible: false},
            const panelBaseVisible = Platform.isMobile() ? false: true
            //TODO: change it
            //UISignals.setFreeSpinLeft.dispatch(UIFacade.model.amountLeft)
            UISignals.setStateUIPanels.dispatch({
                panelBase: {enable: false, visible: panelBaseVisible},
                //panelFS: {visible: true},
                activeBets: {enable: false, visible: true}
            })
        } else {
            UISignals.setStateUIPanels.dispatch({
                panelBase: {enable: true, visible: true},
                panelFS: {visible: false},
                activeBets: {enable: true, visible: true}
            })
        }
    }

    onSetBuyFreeSpin(e) {
        UISignals.setStateUIPanels.dispatch({
            panelBase: {enable: false, visible: true},
            activeBets: {enable: false, visible: true}
        })
    }

    onSetFreespinsLeft(e) {
        const detail = e.detail
        UIFacade.model.freeSpinLeft = detail.value
        if (detail.total !== 0) {
            UIFacade.model.freeSpinTotalCount = detail.total
        }
        UISignals.setValue.dispatch('freespinsLeftDynamic', detail.value)
        UISignals.setStateUIPanels.dispatch({
            panelFS: {visible: true}
        })
       // if (UIFacade.model.freeSpinTotalCount - detail.value > 0) {
            UISignals.setFreeSpinLeft.dispatch(detail.value)
        //}
    }

    onSetTotalWin(e) {
        const detail = e.detail
        UISignals.setValue.dispatch('fsTotalWinDynamic', detail.value)
    }

    onShow() {
        setTimeout(() => {
            UIFacade.menuContainer.show()
        }, 50)
    }

    onHide() {
        UIFacade.menuContainer.hide()
    }

    onShowComponent(e) {
        const detail = e.detail
        UISignals.showComponent.dispatch(detail.name)
    }

    onHideComponent(e) {
        const detail = e.detail
        UISignals.hideComponent.dispatch(detail.name)
    }

    onSetButtonState(data) {
        this.uiView.setButtonState(data.detail)
    }

    onSetWin(data) {
        /// TODO: fix it
        console.log('@@@@@ onSetWin', data.detail.value,  UIFacade.model.scoreWin)
        if(Facade.model.stateMachine.prevStateName.gameState !== 'OUTRO_FREESPINS'){
            UIFacade.model.scoreWin = data.detail.value;
            console.log('@@@@@ -onSetWin', UIFacade.model.scoreWin)
            UISignals.setValue.dispatch('winDynamic', UIFacade.model.scoreWin)
            UISignals.setWinUI.dispatch(UIFacade.model.scoreWin)
        }
    }

    onSetBalance(data) {
       // UISignals.setValue.dispatch('balanceDynamic', data.detail.value)
        UIFacade.model.balance = data.detail.value
        UISignals.setBalance.dispatch(UIFacade.model.balance)
    }

    onSetBet(e) {
        if (!UIFacade.model.setPossibleBets) {
            return
        }
        const detail = e.detail
        UIFacade.model.currentBetIndex = e.detail.currentBetIndex
        let bet = UIFacade.model.setPossibleBets[UIFacade.model.currentBetIndex]
        UISignals.setValue.dispatch('betDynamic', bet)
        UISignals.setValue.dispatch('betSettingValueDynamic', bet)
        UISignals.setBet.dispatch(bet)
    }

    onSetLines(e) {
        const detail = e.detail
        UISignals.setValue.dispatch('linesDynamic', detail.value)
    }

    onSetAutospinValue(data) {
        const currentCountSpins = data.detail.value
        //let t = detail.value == -1 ? '∞' : detail.value
        UISignals.setAutoplayStart.dispatch(currentCountSpins)
    }

    onSetAutospinStop(){
        UISignals.stopAutoplay.dispatch()
    }

    onTap(e) {
        const detail = e.detail
        console.log('Tap  ', detail)
        switch ( detail.name ) {

            case "menu":
                //Signals.showComponent.dispatch("menuPopupLayout")
                document.dispatchEvent(new CustomEvent('menuPopup', {detail: {page: 'menuPage'}}))
                break
            case "menu_BUTTON":
                document.dispatchEvent(new CustomEvent('menuPopup', {detail: {page: 'menuPage'}}))
                break
            case "maxBet":
                document.dispatchEvent(new CustomEvent('menuPopup', {detail: {page: 'betPage'}}))
                break

            case "settingsMusic":
                break

            case "plus":
                UIFacade.model.betIncrease()
                this.betChange()
                //TODO: change it

                break

            case "minus":
                UIFacade.model.betDecrease()
                this.betChange()

                break

            case "autoplay":
                document.dispatchEvent(new CustomEvent('menuPopup', {detail: {page: 'autoplayPage'}}))
                break

            case "betConfirm":
                this.betChange()
                break

            case "info":
                document.dispatchEvent(new CustomEvent('menuPopup', {detail: {page: 'infoPage'}}))
                break
            case "space":
                Facade.isSpaceToSpin = detail.value
                break
        }
    }

    onBetChange(currentBetIndex){
        document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'betChangeBuy', value: currentBetIndex}}))
    }

    betChange(){
        UISignals.setValue.dispatch('betSettingValueDynamic', UIFacade.model.setPossibleBets[UIFacade.model.currentBetIndex])
        UISignals.setBet.dispatch(UIFacade.model.setPossibleBets[UIFacade.model.currentBetIndex])
        UISignals.currentBuyFreebetChanged.dispatch()
        //
        const value = UIFacade.model.currentBetIndex
        document.dispatchEvent(new CustomEvent('betChangeUi', {
            detail: {
                value: value
            }
        }))



        document.dispatchEvent(new CustomEvent('betConfirm', {
            detail: {
                value: this._currentBetIndex, name: 'betConfirm'
            }
        }))
    }

    onShowPopup(data) {
        this.uiView.showPopup()
    //    UIFacade.systemDIV.innerHTML = data.detail.innerhtml
        document.dispatchEvent(new CustomEvent('popupSuccessfullyShown', {detail: {}}))
    }

    onClosePopup(e) {
        this.uiView.closePopup()
    }

    onCurrentBetIndexHasChanged(index) {
       // let bet = 10//UIFacade.model.setPossibleBets[UIFacade.model.currentBetIndex]
        UIFacade.model.currentBetIndex = index
        let bet = UIFacade.model.setPossibleBets[UIFacade.model.currentBetIndex]
        UISignals.setValue.dispatch('betDynamic', bet)
        UISignals.setValue.dispatch('betSettingValueDynamic', bet)
    }

    hideAutoplay() {
        UISignals.hideAutoplay.dispatch()

    }


}
